module.exports = __webpack_public_path__ + "img/logo_doga.db1d6f49.jpg";